import { Injectable} from '@angular/core';

import * as marked from 'marked';

interface IMarkdownConfig {
  sanitize?: boolean;
  gfm?: boolean;
  breaks?: boolean;
  smartypants?: boolean;
}

@Injectable()
export class MarkdownService {
  private md: any;

  constructor() {
    this.md = marked.setOptions({});
  }

  setConfig(config: IMarkdownConfig) {
    this.md = marked.setOptions(config);
  }

  parse(markdown: string): string {
    if (!markdown) {
      return '';
    }
    return this.md.parse(markdown);
  }

}
